import { Material, StructuralLayer } from "../../materials";

import { FC, memo } from "react";
import { MaterialStructureElementTable } from "./MaterialStructureElementTable";
import { Formik } from "formik";
import { FormBase } from "@components-common/forms";

export type ParameterStructure = {
  interior: StructuralLayer[];
  core: StructuralLayer[];
  exterior: StructuralLayer[];
};

export type ParameterStructureView = {
  materialOptions: any[];
  functionOptions: any[];
};

export type ITypesMaterialStructure = {
  viewModel: ParameterStructureView;
};

/**
 * Functional Component: TypesMaterialStructure
 *
 * This memoized component renders tables for different material structure elements (exterior, core, interior).
 *
 * Props:
 * @param {Object} props - The properties passed to the component.
 * @param {any} props.viewModel - The view model containing options for materials and functions.
 *
 * Returns:
 * @returns {JSX.Element} A JSX element containing the material structure element tables.
 */

export const TypesMaterialStructure: React.FC<{ viewModel: any }> = memo(
  ({ viewModel }) => {
    return (
      <>
        {viewModel.materialOptions.length === 0 && (
          <h6 className="text-danger fw-bold mb-2">
            There are no materials created.
          </h6>
        )}
        <MaterialStructureElementTable
          heading={"exterior"}
          viewModel={viewModel}
        />
        <MaterialStructureElementTable heading={"core"} viewModel={viewModel} />
        <MaterialStructureElementTable
          heading={"interior"}
          viewModel={viewModel}
        />
      </>
    );
  }
);
